import { aoSeries, numericExtent } from "../utils";
const AO = {
    name: "AO",
    compute: (bars) => aoSeries(bars),
    computeExtents: (values) => numericExtent(values),
    render: () => undefined,
};
export default AO;
